import { render, staticRenderFns } from "./ResultMsgModal.vue?vue&type=template&id=5349b6bd"
import script from "./ResultMsgModal.vue?vue&type=script&lang=js"
export * from "./ResultMsgModal.vue?vue&type=script&lang=js"
import style0 from "./ResultMsgModal.vue?vue&type=style&index=0&id=5349b6bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports